// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bread-crumbs ul li:not(:last-child):after{content:\"/\";font-size:.875rem;padding-left:.5rem;padding-right:.5rem;--tw-text-opacity:1;color:#999;color:rgba(153,153,153,var(--tw-text-opacity))}.bread-crumbs ul .nuxt-link-exact-active{--tw-text-opacity:1;color:#666;color:rgba(102,102,102,var(--tw-text-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
